import type { Schedule } from "@smartsuite/automation-engine-api";

export const validateScheduleInput = (schedule: Schedule): boolean => {
  if (schedule.schedule !== undefined) {
    return schedule.schedule.schedule.oneofKind !== undefined;
  }

  return !schedule.cron.includes("X");
};
